// extracted by mini-css-extract-plugin
export default {"tabs":"imW6fhyyDoY2zTj6dQdF","redDot":"yWZo6Mo0rZkE6oBJHslg","tabLabel":"dp5HllsEhMoyGw9P9rdW"};